import { forwardRef } from 'react';
import { useApolloClient } from '@apollo/client';
import { AsyncCellSelect } from '@aleph/shared-components';
import { getRedditCustomAudienceOptions } from 'wb-reddit/app/routes/superGrid/targeting/utils';
import { orderBy } from 'lodash';
import { ICellEditorParams, ICellEditor } from 'ag-grid-community';

interface IAudienceCellEditorParams extends ICellEditorParams {
	adAccountId: string;
	loadOptions: (inputValue: string) => Promise<any>;
}

const AudienceCellEditor = forwardRef<ICellEditor, IAudienceCellEditorParams>((
	params,
	ref,
) => {
	const client = useApolloClient();

	const loadRedditOptions = async (value: string) => orderBy(await getRedditCustomAudienceOptions({
		client,
		search:      value,
		adAccountId: params.adAccountId,
	}), (option) => ((params.value ?? []).some(v => v?.value === option?.value) ? -1 : 0));

	return (
		<AsyncCellSelect
			ref={ref}
			{...params}
			loadOptions={loadRedditOptions}
			isMulti={true}
			selectedValue={params?.value}
			stopEditing={params.stopEditing}
		/>
	);
});

export default AudienceCellEditor;
